<template>
  <div class="footer ov">
    <div class="foot ov">
        <div class="f01 ov"><img :src="webLogo" /></div>
        <dl class="f02 ov">
            <dt>{{$t('footer.dd')[0].dt}}<b></b></dt>
              <dd>
                <a @click="path(1,'')">{{$t('footer.dd')[0].dd[0].title}}</a>
                <a @click="path('','help')">{{$t('footer.dd')[0].dd[1].title}}</a>
                <a @click="path(3,'')">{{$t('footer.dd')[1].dd[0].title}}</a>
                <a @click="path(5,'')">{{$t('footer.dd')[1].dd[1].title}}</a>
                <a @click="link">{{$t('footer.dd')[2].dt}}</a>
              </dd>
          </dl>
        <dl class="f02 ov">
            <dt>{{$t('newIndex2.lmdh')}}<b></b></dt>
              <dd>
                  <a @click="jump('/market')">{{$t('nav.nav')[1].title}}</a>
                  <a @click="jump('/deal_jg')">{{$t('nav.nav')[2].title}}</a>
                  <a @click="jump('/profit_index')">{{$t('nav.nav')[3].title}}</a>
                  <a @click="jump('/currency')">{{$t('wydb.db')}}</a>
                  <a @click="jump('/subscription')">{{$t('xbsg.title')}}</a>
                  <a @click="jump('/table1')">{{$t('nav.btn')[2]}}</a>
              </dd>
          </dl>
    </div>
    <div class="bq ov">{{ p }}</div>
</div>
</template>

<script>
import icon1 from "@/assets/index-footer-icon1.png";
import icon2 from "@/assets/index-footer-icon2.png";
import icon3 from "@/assets/index-footer-icon3.png";
import icon4 from "@/assets/index-footer-icon4.png";
import icon5 from "@/assets/index-footer-icon5.png";
import icon6 from "@/assets/index-footer-icon6.png";
import icon7 from "@/assets/index-footer-icon7.png";
import icon8 from "@/assets/index-footer-icon8.png";
import { getLogo,getParam } from "@/api/index";

export default {
  data() {
    return {
      icon: [[icon1, icon2, icon3, icon4], [icon5, icon6, icon7, icon8]],
      p: this.$t("footer.p"),
      dl: this.$t("footer.dd"),
      flogo: '',
      online_service: ''
    };
  },
  created(){
    this.online_service = localStorage.getItem('online_service');
  },
  mounted() {
    // getLogo({key:'web_logo'}).then(res => {
    //   sessionStorage.setItem('web_footer_logo', res)
    //   this.flogo = res
    // });
    getParam().then(res => {
      for(var i=0;i< res.length; i++){
        if(res[i].key == 'android_link'){
          this.android_link = res[i].value.replace(/(^\s*)|(\s*$)/g, "");
        }else if(res[i].key == 'ios_link'){
          this.ios_link = res[i].value.replace(/(^\s*)|(\s*$)/g, "");
        }else if(res[i].key == 'tf_link'){
          this.tf_link = res[i].value.replace(/(^\s*)|(\s*$)/g, "");
        }else if(res[i].key == 'online_service'){
          localStorage.setItem('online_service',res[i].value.replace(/(^\s*)|(\s*$)/g, ""))
        }else if(res[i].key == 'online_service2'){
          localStorage.setItem('online_service2',res[i].value.replace(/(^\s*)|(\s*$)/g, ""))
        }else if(res[i].key == 'ios_link_2'){
          this.ios_link_2 = res[i].value.replace(/(^\s*)|(\s*$)/g, "");
        }else if(res[i].key == 'ios_current_link'){
          this.ios_current_link = res[i].value.replace(/(^\s*)|(\s*$)/g, "");
        }
      }
    });
  },
  methods: {
    path(id,type) {
      if(type == 'help'){
        this.$router.push({
          path: "/help",
          query: { id,type }
        });
      }else if(id == 1){
        this.$router.push({
          path: "/about",
          query: { id,type }
        });
      }else if(id == 3){
        this.$router.push("/agrt");
      }else{
        this.$router.push("/text");
      }
    },
    jump(url){
      this.$router.push(url);
    },
    link(){
      if(!this.online_service) return;
      window.open(this.online_service);
    }
  }
};
</script>

<style scoped lang="scss">
.footer{ width:100%; background-color:#040f1f; margin-top:70px;}
.footer .foot{ width:1200px; margin:auto; padding:50px 0;}
.footer .foot .f01{ width:23%; float:left;}
.footer .foot .f01 img{ display:block; margin-top:40px;}
.footer .foot .f02{ width:35%; float:left; display:block;}
.footer .foot .f02 dt{ display:block; font-size:20px; line-height:30px; text-transform:uppercase; color:#fff;}
.footer .foot .f02 dt b{ display:block; width:30px; height:2px; background-color:#00d5fd; overflow:hidden; margin:10px 0;}
.footer .foot .f02 dd{ display:block; overflow:hidden;}
.footer .foot .f02 dd a{ display:block; width:45%; float:left; font-size:16px; line-height:26px; color:#fff;}
.footer .foot .f02 dd a:hover{ color:#00d5fd;}
.footer .foot .f03{ width:20%; float:right; display:block;}
.footer .foot .f03 dt{ display:block; font-size:20px; line-height:30px; text-transform:uppercase; color:#fff;}
.footer .foot .f03 dt b{ display:block; width:30px; height:2px; background-color:#00d5fd; overflow:hidden; margin:10px 0;}
.footer .foot .f03 dd{ display:block; overflow:hidden;}
.footer .foot .f03 dd a{ display:block; width:100%; float:left; font-size:16px; line-height:26px; color:#fff;}
.footer .foot .f03 dd a:hover{ color:#00d5fd;}
.footer .bq{ text-align:center; width:100%; background-color:#010711; padding:15px 0; font-size:14px; line-height:24px; color:#99b3da;}

</style>



// WEBPACK FOOTER //
// src/components/AoFooter.vue